/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Table_Ageratings2Inputs */

const id_offerdetail_table_ageratings2 = /** @type {(inputs: Offerdetail_Table_Ageratings2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peringkat Usia`)
};

const ms_offerdetail_table_ageratings2 = /** @type {(inputs: Offerdetail_Table_Ageratings2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penarafan Umur`)
};

const da_offerdetail_table_ageratings2 = /** @type {(inputs: Offerdetail_Table_Ageratings2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aldersvurderinger`)
};

const de_offerdetail_table_ageratings2 = /** @type {(inputs: Offerdetail_Table_Ageratings2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Altersfreigaben`)
};

const en_us2_offerdetail_table_ageratings2 = /** @type {(inputs: Offerdetail_Table_Ageratings2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Age Ratings`)
};

const es_es2_offerdetail_table_ageratings2 = /** @type {(inputs: Offerdetail_Table_Ageratings2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clasificaciones por edad`)
};

const es_mx2_offerdetail_table_ageratings2 = /** @type {(inputs: Offerdetail_Table_Ageratings2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clasificaciones por edad`)
};

const fil_offerdetail_table_ageratings2 = /** @type {(inputs: Offerdetail_Table_Ageratings2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Rating ng Edad`)
};

const fr_offerdetail_table_ageratings2 = /** @type {(inputs: Offerdetail_Table_Ageratings2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Classifications par âge`)
};

const it_offerdetail_table_ageratings2 = /** @type {(inputs: Offerdetail_Table_Ageratings2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Classificazioni età`)
};

const hu_offerdetail_table_ageratings2 = /** @type {(inputs: Offerdetail_Table_Ageratings2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Korhatár besorolások`)
};

const nl_offerdetail_table_ageratings2 = /** @type {(inputs: Offerdetail_Table_Ageratings2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leeftijdsclassificaties`)
};

const no_offerdetail_table_ageratings2 = /** @type {(inputs: Offerdetail_Table_Ageratings2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aldersvurderinger`)
};

const pl_offerdetail_table_ageratings2 = /** @type {(inputs: Offerdetail_Table_Ageratings2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klasyfikacje wiekowe`)
};

const pt_br2_offerdetail_table_ageratings2 = /** @type {(inputs: Offerdetail_Table_Ageratings2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Classificações etárias`)
};

const pt_offerdetail_table_ageratings2 = /** @type {(inputs: Offerdetail_Table_Ageratings2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Classificações etárias`)
};

const ro_offerdetail_table_ageratings2 = /** @type {(inputs: Offerdetail_Table_Ageratings2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clasificări de vârstă`)
};

const fi_offerdetail_table_ageratings2 = /** @type {(inputs: Offerdetail_Table_Ageratings2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ikärajat`)
};

const sv_offerdetail_table_ageratings2 = /** @type {(inputs: Offerdetail_Table_Ageratings2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Åldersklassificeringar`)
};

const vi_offerdetail_table_ageratings2 = /** @type {(inputs: Offerdetail_Table_Ageratings2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xếp hạng độ tuổi`)
};

const tr_offerdetail_table_ageratings2 = /** @type {(inputs: Offerdetail_Table_Ageratings2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yaş Sınırları`)
};

const cs_offerdetail_table_ageratings2 = /** @type {(inputs: Offerdetail_Table_Ageratings2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Věkové hodnocení`)
};

const bg_offerdetail_table_ageratings2 = /** @type {(inputs: Offerdetail_Table_Ageratings2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Възрастови ограничения`)
};

const ru_offerdetail_table_ageratings2 = /** @type {(inputs: Offerdetail_Table_Ageratings2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Возрастные рейтинги`)
};

const uk_offerdetail_table_ageratings2 = /** @type {(inputs: Offerdetail_Table_Ageratings2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вікові рейтинги`)
};

const ar_offerdetail_table_ageratings2 = /** @type {(inputs: Offerdetail_Table_Ageratings2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التصنيفات العمرية`)
};

const hi_offerdetail_table_ageratings2 = /** @type {(inputs: Offerdetail_Table_Ageratings2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आयु रेटिंग`)
};

const th_offerdetail_table_ageratings2 = /** @type {(inputs: Offerdetail_Table_Ageratings2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เรตอายุ`)
};

const ja_offerdetail_table_ageratings2 = /** @type {(inputs: Offerdetail_Table_Ageratings2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`年齢レーティング`)
};

const zh_cn2_offerdetail_table_ageratings2 = /** @type {(inputs: Offerdetail_Table_Ageratings2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`年龄分级`)
};

const zh_hant1_offerdetail_table_ageratings2 = /** @type {(inputs: Offerdetail_Table_Ageratings2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`年齡分級`)
};

const ko_offerdetail_table_ageratings2 = /** @type {(inputs: Offerdetail_Table_Ageratings2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`연령 등급`)
};

/**
* | output |
* | --- |
* | "Age Ratings" |
*
* @param {Offerdetail_Table_Ageratings2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_table_ageratings2 = /** @type {((inputs?: Offerdetail_Table_Ageratings2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Table_Ageratings2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_table_ageratings2(inputs)
	if (locale === "ms") return ms_offerdetail_table_ageratings2(inputs)
	if (locale === "da") return da_offerdetail_table_ageratings2(inputs)
	if (locale === "de") return de_offerdetail_table_ageratings2(inputs)
	if (locale === "en-US") return en_us2_offerdetail_table_ageratings2(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_table_ageratings2(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_table_ageratings2(inputs)
	if (locale === "fil") return fil_offerdetail_table_ageratings2(inputs)
	if (locale === "fr") return fr_offerdetail_table_ageratings2(inputs)
	if (locale === "it") return it_offerdetail_table_ageratings2(inputs)
	if (locale === "hu") return hu_offerdetail_table_ageratings2(inputs)
	if (locale === "nl") return nl_offerdetail_table_ageratings2(inputs)
	if (locale === "no") return no_offerdetail_table_ageratings2(inputs)
	if (locale === "pl") return pl_offerdetail_table_ageratings2(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_table_ageratings2(inputs)
	if (locale === "pt") return pt_offerdetail_table_ageratings2(inputs)
	if (locale === "ro") return ro_offerdetail_table_ageratings2(inputs)
	if (locale === "fi") return fi_offerdetail_table_ageratings2(inputs)
	if (locale === "sv") return sv_offerdetail_table_ageratings2(inputs)
	if (locale === "vi") return vi_offerdetail_table_ageratings2(inputs)
	if (locale === "tr") return tr_offerdetail_table_ageratings2(inputs)
	if (locale === "cs") return cs_offerdetail_table_ageratings2(inputs)
	if (locale === "bg") return bg_offerdetail_table_ageratings2(inputs)
	if (locale === "ru") return ru_offerdetail_table_ageratings2(inputs)
	if (locale === "uk") return uk_offerdetail_table_ageratings2(inputs)
	if (locale === "ar") return ar_offerdetail_table_ageratings2(inputs)
	if (locale === "hi") return hi_offerdetail_table_ageratings2(inputs)
	if (locale === "th") return th_offerdetail_table_ageratings2(inputs)
	if (locale === "ja") return ja_offerdetail_table_ageratings2(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_table_ageratings2(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_table_ageratings2(inputs)
	return ko_offerdetail_table_ageratings2(inputs)
});
export { offerdetail_table_ageratings2 as "offerDetail.table.ageRatings" }